import { render, staticRenderFns } from "./replacementReasons.vue?vue&type=template&id=b8a11122"
import script from "./replacementReasons.vue?vue&type=script&lang=js"
export * from "./replacementReasons.vue?vue&type=script&lang=js"
import style0 from "./replacementReasons.vue?vue&type=style&index=0&id=b8a11122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports